import { RestClient } from './RestClient'

export class TextTemplateClient extends RestClient {
  /**
   * TextTemplateClient constructor
   *
   * @constructor
   */
  constructor () {
    super()

    if (new.target === TextTemplateClient) {
      throw new TypeError('Cannot construct Abstract instances directly')
    }
  }

  /**
   * Get a list of text templates
   *
   * @returns {AxiosPromise}
   */
  list () {
    return this.call('get', this.baseUrl)
  }

  /**
   * Create a new text template
   *
   * @param {Object} data - Text template info
   *
   * @returns {AxiosPromise}
   */
  create (data) {
    return this.call('post', this.baseUrl, data)
  }

  /**
   * Update an existing text template
   *
   * @param {number} templateId - Text template id
   * @param {Object} data - Text template info
   *
   * @returns {AxiosPromise}
   */
  update (templateId, data) {
    return this.call('patch', `${this.baseUrl}/${templateId}`, data)
  }

  /**
   * Delete the specified text templates
   *
   * @param {(...number|number[])} templateId - Text templates which should be deleted
   *
   * @returns {AxiosPromise}
   */
  destroy (...templateId) {
    return this.call('delete', `${this.baseUrl}/${this.parseAndJoin(templateId)}`)
  }
}
